export default {
  loadingWebsites: "Websites werden geladen...",
  website: "Website",
  websiteLoading: "Einrichtungen werden geladen",
  guide: {
    show: "Leitfaden anzeigen",
  },
  dataAgreement: {
    title: "Aktualisierung der DSGVO-bezogenen Informationen",
    save: {
      success: "Daten erfolgreich gespeichert!",
    },
    alert_link: "hier.",
    alert:
      "Im Rahmen der Verpflichtungen zur Einhaltung der DSGVO-Norm ist es erforderlich, dass Sie die nachstehenden Felder ausfüllen, damit die Benutzer Ihrer Plattform Sie als Verantwortlichen für die Datenverarbeitung identifizieren können.\n" +
      "Diese Daten werden verwendet, um die Seite zur Verwaltung der Datenschutzrichtlinie der Plattform zu vervollständigen, die Sie einsehen können",
  },
};
